/**
 * WONE-612: legacy `/signin` hub retired in favour of the unified
 * email-first entry at `/email-entry`. Kept as a thin redirect so
 * pre-existing deep links (e.g. emailed reset CTAs, internal /signin
 * imports in pages/index.js) keep working.
 */

import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const SignIn: React.FC = () => {
  const location = useLocation();
  return (
    <Navigate
      to={`/email-entry${location.search || ""}`}
      replace
      state={location.state}
    />
  );
};

export default SignIn;
